<template>
    <div>
        <b-overlay :show="loading">

            <vehicle-advanced-modal-component
                class="container-xl d-none text-center d-lg-block"
                :showModal="showModal"
                :qRequest="qRequest"
                :searchFilters="searchFilters"
                :vehicleRoute="vehicleRoute"
                :vehicleSearch="vehicleSearch"
                :advancedSearch="advancedSearch"
                v-on:toggleModal="(e) => showModal = e"
                v-on:runSearch="(e) => runSearch(e, false)"
                v-on:resetSearch="(e) => runSearch(e, true)"
                ></vehicle-advanced-modal-component>

            <div v-if="!_.isEmpty(searchtags) || !_.isNull(keywordRequest)" class="applied-filters bg-grey-light d-lg-none overflow-hidden">
                <div class="container-xl">
                    <div class="search-filters pt-3_ pt-lg-0">
                        <label>Your applied filters:</label>
                        <div class="filter-overflow">
                            <span v-if="!_.isNull(keywordRequest)"
                                v-on:click="removeKeywords()"
                                class="searchfiltertag me-1 bg-primary">
                                {{ keywordRequest }}
                                <span class="material-icons">close</span>
                            </span>
                            <span v-for="tag in searchtags"
                                :key="tag.key"
                                v-on:click="removeTag(tag.key)"
                                class="searchfiltertag me-1">
                                {{ tag.value }}
                                <span class="material-icons">close</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="hasTags" class="search-filters bg-grey-light d-none d-lg-block">
                <label>Your applied filters:</label>

                <span v-if="!_.isNull(keywordRequest)"
                    v-on:click="removeKeywords()"
                    class="searchfiltertag ms-1 bg-primary">
                    {{ keywordRequest }}
                </span>

                <span v-for="tag in searchtags"
                    :key="tag.key"
                    v-on:click="removeTag(tag.key)"
                    class="searchfiltertag ms-1">
                    {{ tag.value }}
                </span>

                <div class="d-block d-md-inline-block">
                    <a href="javascript:void(0);"
                        v-on:click="showModal = true"
                         class="btn btn-default">
                        <span class="material-icons me-2">tune</span>
                        Refine search
                    </a>
                    <template v-if="_.get(customer.attributes, 'registered', false)">
                        <button v-if="savedsearch"
                            v-on:click="editSearch"
                            type="button"
                            class="btn btn-link btn-outline btn-editAlert">
                            <span>Edit Alert</span>
                        </button>
                        <button v-else
                            v-on:click="saveSearch"
                            type="button"
                            class="btn btn-primary btn-setAlert">
                            <span><span class="material-icons me-2">notifications</span>Receive Alerts</span>
                        </button>
                    </template>
                    <template v-else>
                        <button type="button" class="btn btn-primary"
                            data-bs-toggle="modal"
					        data-bs-target="#signin-modal">
                            <span class="material-icons me-1">notifications</span> Receive Alerts
                            </button>
                    </template>
                </div>
            </div>
            <div class="list-vehicles bg-grey-light" id="vehicle-listings">
                <div class="listings-search--container container-xl lower">
                    <div class="listings-search d-lg-none d-xl-none">
                        <div class="position-relative w-100 ">
                            <span class="search-btn material-icons">search</span>
                            <input v-model="currentQuery.keywords"
                                v-on:keyup="keywordKeyup"
                                name="keywords"
                                type="text"
                                placeholder="Search vehicles by keyword"
                                value="">
                            <button v-if="!_.isNull(currentQuery.keywords)" type="button"
                                v-on:click="removeKeywords()"
                                class="reset-keywords"
                                title="Reset keywords">
                                <span class="material-icons">close</span>
                            </button>
                        </div>
                        <button type="button"
                            v-on:click="showModal = true"
                            class="btn"
                            title="Vehicle search">
                            <span class="material-icons">tune</span>
                        </button>

                        <template v-if="listingsearch">
                            <template v-if="_.get(customer.attributes, 'registered', false)">
                                <button v-if="savedsearch"
                                    v-on:click="editSearch"
                                    type="button"
                                    class="btn btn-primary btn-editAlert text-nowrap"
                                    title="View saved alerts">
                                    <span>Edit Alert</span>
                                </button>
                                <button v-else type="button"
                                    v-on:click="saveSearch"
                                    class="btn btn-primary btn-setAlert text-nowrap px-2 px-md-3"
                                    title="Receive alerts for this search">
                                    <span class="material-icons me-md-1 d-lg-none">notifications</span>
                                    <span class="d-none d-md-inline">Receive Alerts</span>
                                </button>
                            </template>
                            <template v-else>
                                <button v-if="hasTags" type="button"
                                    class="btn btn-primary text-nowrap px-2 px-md-3"
                                    data-bs-toggle="modal"
                                    data-bs-target="#signin-modal">
                                    <span class="material-icons me-md-1 d-lg-none">notifications</span>
                                    <span class="d-none d-md-inline">Receive Alerts</span>
                                </button>
                            </template>
                        </template>
                    </div>
                </div>

                <div class="listings-row-sort container-xxl py-md-3 py-lg-0 px-lg-7 d-flex justify-content-between">

                        <form method="POST" class="form-inline d-flex align-items-center w-100" id="sort-filter" >
                            <label for="filter-sort" class="visually-hidden">Sort cars by</label>
                            <div class="mb-1">
                                <select name="orderby"
                                    :disabled="loading || skeleton || _.isEmpty(listings)"
                                    v-model="orderBy"
                                    id="filter-sortby"
                                    class="form-select--gradient form-select"
                                    data-title="Sort by"
                                    data-style="btn-xs-block"
                                    ref="selectpicker">
                                    <option :value="null">Sort by</option>
                                    <option value="manufacturer,model">Sort by Make/Model (A-Z)</option>
                                    <option value="datecreated DESC">Latest Listings</option>
                                    <option value="year">Sort by Oldest first</option>
                                    <option value="year DESC">Sort by Newest first</option>
                                    <option value="discount_amount">Sort by Highest Savings first</option>
                                    <option value="retailprice">Sort by Lowest Price first</option>
                                    <option value="retailprice DESC">Sort by Highest price first</option>
                                    <option value="odometer">Sort by Lowest KMs</option>
                                    <option value="odometer DESC">Sort by Highest KMs</option>
                                </select>
                            </div>
                            <p :class="[loading || skeleton ? 'opacity-0' : 'opacity-100', 'matches', 'text-start', 'text-nowrap', 'ms-lg-3', 'mb-0']">Showing {{ pagination.total_records }} cars</p>
                        </form>
                        <div class="list-btns d-none d-lg-flex">
                            <div class="btn-group btn-group-branch">
                                <button type="button"
                                    v-on:click="changeBranch(null)"
                                    :class="[_.isNull(qRequest.branchid) || _.isUndefined(qRequest.branchid) || _.isEmpty(qRequest.branchid) ? 'active' : '', 'btn btn-default text-nowrap filter-branch']">All</button>
                                <button v-for="branch in branches"
                                    :key="branch.id"
                                    type="button"
                                    v-on:click="changeBranch(branch.id)"
                                    :class="[_.includes(qRequest.branchid, branch.id) ? 'active' : '', 'btn btn-default text-nowrap filter-branch']">
                                    {{ branch.name }}
                                </button>
                            </div>
                            <!-- <div class="btn-group layout-swap d-none d-md-block">
                                <a href="javascript:void()" v-on:click="viewtype = 'grid'" id="grid" :class="['btn-grid', viewtype == 'grid' ? 'active' : '']"><span></span></a>
                                <a href="javascript:void()" v-on:click="viewtype = 'list'" id="list" :class="['btn-list', viewtype == 'list' ? 'active' : '']"><span></span></a>
                            </div> -->
                        </div>
                </div>

                <div class="container-xxl px-lg-7 position-relative vehicle-listings-bg">


              <!-- Terms modal popup -->
                <terms-modal-component
                    :termsModalSavings="termsModalSavings"
                    :termsModalFullPrice="termsModalFullPrice"
                />


                    <!-- Skeleton -->
                    <div v-show="skeleton" :class="['skeleton-row-overlay row']">
                        <vehicle-card-component
                            v-for="index in 5"
                            :key="index-1"
                            :listing="false"
                            :index="index-1"
                            :currentPage="currentPage"
                            :config="{skeleton: true, viewtype}">
                        </vehicle-card-component>
                    </div>
                    <template v-if="!_.isEmpty(listings)">
                        <div class="row list-group d-flex flex-row">
                            <template v-for="listing, index in listings">
                                <vehicle-card-component
                                    :key="listing.id"
                                    :listing="listing"
                                    :index="index"
                                    :currentPage="currentPage"
                                    v-on:iasPage="changeIasPage"
                                    :config="{ skeleton: false, viewtype, noslide: false }"
                                    @updateTermsModal="handleTermsModalUpdate">
                                </vehicle-card-component>

                                <div v-if="canPromo(index, listing._setPage)"
                                    :key="'promocard' + index"
                                    :class="[viewtype == 'grid' ? 'grid-group-item' : 'list-group-item', 'item col-md-6 col-lg-4 col-xl-3 col-xxl-5 search-listing']">
                                    <div class="thumbnail thumbnail-random">
                                        <a :href="canPromo(index, listing._setPage).url" class="promocard-image" >
                                            <img :src="_.imgPath(canPromo(index, listing._setPage).image, '660-h540-c660x540-q80')"
                                                :alt="canPromo(index, listing._setPage).name"
                                                class="img-fluid blur-up" />
                                        </a>
                                        <div class="caption pt-3">
                                            <h3>{{ canPromo(index, listing._setPage).name }}</h3>
                                        </div>
                                        <div class="thumbnail-footer pb-3 pb-md-4">
                                            <a :href="canPromo(index, listing._setPage).url" class="btn btn-primary btn-rnd btn-lg">
                                                {{ canPromo(index, listing._setPage).buttontext ? canPromo(index, listing._setPage).buttontext : 'Learn More' }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="canElfsight(index, listing._setPage)"
                                    :class="[viewtype == 'grid' ? 'grid-group-item' : 'list-group-item', 'item col-xs-12 col-xxxl-20p search-listing grid-group-item lazyload elfsight-listing']"
                                    data-script="https://apps.elfsight.com/p/platform.js"
                                    :key="'elfbanner_' + index">
                                    <div :class="[elfsightBanner, 'elfsight-wrapper']"></div>
                                    <div class="spinner-wrapper-elfsight"><i class="fa fa-spin fa-spinner fa-pulse fa-2x"></i></div>
                                </div>

                            </template>

                            <!-- Lower Pagination -->
                            <div class="d-flex align-items-center flex-column justify-content-center mb-3">
                                <template v-if="currentPage < pagination.last_page">
                                    <button :class="[pageLoading ? 'btn-transparent text-primary' : 'btn-primary text-white', 'btn mb-4 btn-page-loader']"
                                        ref="loadMore"
                                        v-on:click="changePage(currentPage+1, false)">
                                        <template v-if="pageLoading">
                                            <div class="lds-ring-small d-none d-md-block">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </template>
                                        <template v-else>LOAD MORE</template>
                                    </button>
                                    <vehicle-card-component
                                        class="d-block d-md-none"
                                        v-for="index in 1"
                                        :key="index-1"
                                        :listing="false"
                                        :index="index-1"
                                        :currentPage="currentPage"
                                        :config="{skeleton: true, viewtype}"
                                        @updateTermsModal="handleTermsModalUpdate">
                                    </vehicle-card-component>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="!skeleton">
                        <template v-if="!_.isEmpty(otherSuggestions)">
                            <h5 class="text-center mt-2 mb-4">{{ otherSuggestions.stringText }}</h5>
                            <div class="row list-group d-flex flex-row">
                                <vehicle-card-component
                                    v-for="suglisting, index in otherSuggestions.listings"
                                    :key="suglisting.id"
                                    :listing="suglisting"
                                    :index="index"
                                    :config="{ skeleton: false, viewtype, noslide: true, related: true }"
                                    @updateTermsModal="handleTermsModalUpdate">
                                </vehicle-card-component>
                            </div>
                        </template>
                        <h5 v-else class="text-center py-4 m-0">No listings found.</h5>
                    </template>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import UtilsMixin from '../UtilsMixin';
import VehicleCardComponent from './VehicleCardComponent';
import VehicleAdvancedModalComponent from './VehicleAdvancedModalComponent';
import TermsModalComponent from '../UI/TermsModalComponent';

export default {

    data() {
        return {
            forceDelay: 0, // set up a delay for dev purposes
            loading: false,
            pageLoading: false,
            skeleton: true,
            // fadeSkeleton: false,
            listings: [],
            currentPage: 1,
            pagination: {},
            path: null,
            qRequest: {},
            orderBy: _.get(this.initialData, 'orderby', null),
            searchtags: {},
            viewtype: 'grid',
            currentQuery: {
                branch_id: [],
                keywords: null,
            },
            showModal: false,
            promocards: _.get(this.initialData, 'promocards', []),
            elfsightBanner: _.get(this.initialData, 'elfsightBanner', false),
            keywordRequest: null,
            customerAlerts: [],
            saveSearchOmit: ['lazyload','orderby','page','seo_url','logsearch','advancedsearch','listingsearch'],
            otherSuggestions: {},
            termsModalSavings: 0,
            termsModalFullPrice: 0,
        }
    },

    props: ['initialData', 'config'],

    mixins: [UtilsMixin],

    components: {
        VehicleCardComponent,
        VehicleAdvancedModalComponent,
        TermsModalComponent,
    },

    created() {
        let params = new URLSearchParams(window.location.search);
        if (params.has('page')) {
            this.currentPage = params.get('page');
        }
        if (!_.isEmpty(this.initialData.request)) {
            this.qRequest = _.get(this.initialData, 'request', {});
        }
        this.searchtags = _.get(this.initialData, 'searchtags', {}).map((st) => {
            return {
                key: st.key,
                value: this.decodeTagValue(st.value)
            }
        });

        this._keywordSearch = _.debounce(function(e) {
            this.keywordSearch(e);
        }, 1000);

        this.customerAlerts = _.get(this.customer.attributes, 'alerts', []);

        window.addEventListener('scroll', this.lazyLoad);
    },

    unmounted () {
        window.removeEventListener('scroll', this.lazyLoad);
    },

    mounted() {

        // define current branch
        if (_.get(this.qRequest, 'branchid', [])) {
            this.currentQuery.branch_id = _.get(this.qRequest, 'branchid', []).map(bi => parseInt(bi));
        }
        if (_.get(this.qRequest, 'branchnameid', null)) {
            this.currentQuery.branch_id = [this.branches.find(b => b.nameid == _.get(this.qRequest, 'branchnameid', null))];
        }

        // define keywords
        this.currentQuery.keywords = this.keywordRequest = _.get(this.qRequest, 'keywords', null);

        // run initial query
        this.queryVehicles(true).then(() => {
            // this is for fade
            // this.fadeSkeleton = true;
            setTimeout((e) => {
                this.skeleton = false;
                // this.fadeSkeleton = false;
                this.initJS();
            }, 300);
        });
    },

    computed: {

        listingsearch() {
            return !_.isEmpty(_.get(this, 'qRequest', []));
        },

        savedsearch() {
            let matchAlert = this.customerAlerts.filter((alert) => {
                let qRequest = _.omit(this.qRequest, this.saveSearchOmit);
                return _.isEqual(alert.search_criteria, qRequest);
            });
            return matchAlert.length > 0;
        },

        hasTags() {
            if (!_.isNull(this.keywordRequest)) {
                return true;
            }
            return !_.isEmpty(_.get(this, 'searchtags', []));
        },

        branches() {
            return _.get(this.initialData, 'branches', []);
        },

        elfsightStart() {
            if (window.innerWidth >= 2000) {
                return this.promocards.length > 0 ? 8 : 9;
            }
            return this.promocards.length > 0 ? 10 : 11;
        },

        vehicleRoute() {
            return _.get(this.config, 'vehicleRoute', null);
        },

        vehicleSearch() {
            return _.get(this.config, 'vehicleSearch', null);
        },

        alertRoute() {
            return _.get(this.config, 'alertRoute', null);
        },

        searchFilters() {
            return _.get(this.initialData, 'searchFilters', {});
        },

        advancedSearch() {
            return _.get(this.initialData, 'advancedSearch', false);
        },

        availableTags() {
            return _.get(this.initialData, 'availabletags', false);
        },

        perPage() {
            // set collection total
            const winWidth = window.innerWidth;
            if (winWidth >= 2000) {
                return 13;
            }
            return 14;
        },
    },

    watch: {

        orderBy: {
            handler(newVal) {
                this.queryVehicles().then(() => {
                    this.initJS();
                });
            },
            deep: false,
            immediate: false,
        },
    },

    methods: {

        queryVehicles(initialLoad = false, ias = false, scroll = false) {
            return new Promise((resolve, reject) => {
                if (!initialLoad) {
                    this.loading = true;
                }

                let qRequest = {
                    ...this.qRequest,
                    page: this.currentPage,
                }

                let fullpath = new URL(window.location).pathname.split( '/' );
                fullpath.shift();
                this.path = _.first(fullpath);

                const params = new URLSearchParams(qRequest);

                // append lazyload to return json
                params.append('lazyload', true);
                params.append('orderby', this.orderBy);

                // get amount to load
                params.append('per_page', this.perPage);

                axios.get('/vehicles/search?' + params.toString(), {
                }).then((res) => {
                    // this forceDelay is for dev only! because the queries run too fast to test loading / skeleton!
                    setTimeout((e) => {
                        let vehicles = res.data.vehicles.map((l) => {
                            return {
                                ...l,
                                _setPage: params.get('page'),
                            }
                        });
                        if (ias !== false) {
                            let merged;
                            switch (ias) {
                                case 'prepend':
                                    merged = _.unionBy(vehicles, this.listings, 'id');
                                    break;
                                case 'append':
                                    merged = _.unionBy(this.listings, vehicles, 'id');
                                    break;
                            }
                            this.listings = merged;
                        } else {
                            this.listings = vehicles;

                             // Set elfsight / promocards when not paging
                            this.elfsightBanner = _.get(res.data, 'elfsightBanner', false);
                            this.promocards = _.get(res.data, 'promocards', []);
                        }

                        // set timed-out keywords
                        this.keywordRequest = this.currentQuery.keywords;

                        this.qRequest = res.data.request_route;
                        this.setPagination(res.data);
                        window.history.replaceState({}, null, res.data.search_route);
                        const canonical = document.querySelector('link[rel="canonical"]');
                        canonical.href = window.location.origin + res.data.search_route;
                        this.loading = false;
                        if (scroll) {
                            // scrolling??
                            this.scrollTo('layout-vehicles');
                        }

                        // populate suggestions
                        this.otherSuggestions = _.get(res.data, 'suggestions', {});

                        resolve({ complete: true });
                    }, this.forceDelay);
                }).catch((error) => {
                    reject({ complete: false });
                });
            });
        },

        changePage(pageNum, scroll = false, runQuery = true) {

            let ias = false;
            this.pageLoading = true;
            if (pageNum < this.currentPage) {
                ias = 'prepend';
            } else {
                ias = 'append';
            }
            this.currentPage = pageNum;

            if (!runQuery) {
                this.pageLoading = false;
                return;
            }
            this.queryVehicles(true, ias, scroll).then(() => {
                this.initJS();
                this.pageLoading = false;
                if (scroll) {
                    // scrolling??
                    this.scrollTo('layout-vehicles');
                }
            });
        },

        changeIasPage(page) {
            this.currentPage = parseInt(page);
            const params = new URLSearchParams(window.location.search);
            params.set('page', page);
            window.history.pushState(null, null, `?${params.toString()}`);
        },

        editSearch() {
            return window.location.href = this.alertRoute;
        },

        saveSearch() {
            let qRequest = _.omit(this.qRequest, this.saveSearchOmit);
            let alertData = {
                search_criteria: qRequest,
                alert_frequency: 'daily',
                receive_alerts: 1
            }
            return this.api.postData(`/my/alerts`, {}, alertData)
                .then(res => {
                    this.customerAlerts.push(res.attributes);
                })
                .catch(err => {

                });
        },

        setPagination(data) {
            this.currentPage = data.current_page;
            let firstVisible = 1;
            let lastVisible = data.last_page;
            let preConcat = false, postConcat = false;

            if (data.current_page > 5) {
                preConcat = true;
                firstVisible = data.current_page - 5;
            }
            if (data.last_page > 11 && (data.last_page - data.current_page) > 5) {
                postConcat = true;
                lastVisible = firstVisible + 10;
            }

            this.pagination = {
                current_page: data.current_page,
                last_page: data.last_page,
                first_visible: firstVisible,
                last_visible: lastVisible,
                total_records: data.totalrecords,
                pre_concat: preConcat,
                post_concat: postConcat,
                visible_pages: _.range(firstVisible, lastVisible+1),
            }
        },

        runSearch(data, reset = false) {
            let newRequest;
            if (reset) {
                newRequest = data;
            } else {
                newRequest = {
                    ...this.qRequest,
                    ...data,
                }
            }
            this.qRequest = newRequest;

            if (!_.isNull(this.qRequest.branchid)) {
                 this.currentQuery.branch_id = this.qRequest.branchid;
            }
            this.currentQuery.keywords = _.get(this.qRequest, 'keywords', null);

            this.refreshSearchTags();

            // reset to first page
            this.changePage(1, true, false);
            this.queryVehicles(false, false, true).then(() => {
                this.initJS();
            });
        },

        keywordKeyup(e) {
            return e.key == 'Enter' ? this.keywordSearch(e) : this._keywordSearch(e)
        },

        keywordSearch(e) {
            if (_.isNull(this.currentQuery.keywords) || _.isEmpty(this.currentQuery.keywords)) {
                delete this.qRequest['keywords'];
                this.currentQuery.keywords = null;
            } else {
                this.qRequest['keywords'] = this.currentQuery.keywords;
            }
            // reset to first page
            this.changePage(1, true, false);
            this.queryVehicles(false, false, true).then(() => {
                this.initJS();
            });
        },

        changeBranch(branchid) {
            if (_.isNull(branchid)) {
                this.removeTag('branchid');
                this.currentQuery.branch_id = [];
                this.changePage(1, true, false);
                this.queryVehicles(false, false, true).then(() => {
                    this.initJS();
                });
                return;
            }

            if (_.includes(this.currentQuery.branch_id, branchid)) {
                // unset
                this.currentQuery.branch_id = this.currentQuery.branch_id.filter(br => br != branchid);
            } else {
                // add
                this.currentQuery.branch_id.push(branchid);
            }
            this.qRequest['branchid'] = this.currentQuery.branch_id;
            let selectBranches = this.branches.filter(b => _.includes(this.currentQuery.branch_id, b.id));
            if (_.isEmpty(selectBranches)) {
                this.removeTag('branchid');
            } else {
                this.updateSearchTags('branchid', _.join(_.map(selectBranches, 'name'), ', '));
            }
            // reset to first page
            this.changePage(1, true, false);
            this.queryVehicles(false, false, true).then(() => {
                this.initJS();
            });
        },

        refreshSearchTags() {
            let searchtags = [];
            this.availableTags.forEach((tag) => {
                let value;
                let tagValid = false;

                if (_.has(this.qRequest, tag)) {

                    switch (tag) {
                        case 'branchid':
                            let branches = this.branches.filter(b => _.includes(this.qRequest.branchid, b.id));
                            // let branch = this.branches.filter(b => b.id == this.qRequest.branchid);
                            if (!_.isEmpty(branches)) {
                                tagValid = true;
                                value = _.join(_.map(branches, 'name'), ', ');
                            }
                            break;
                        case 'sale':
                            if (this.qRequest[tag]) {
                                tagValid = true;
                                value = 'On Sale';
                            }
                            break;
                        case 'budget_range':
                            if (this.qRequest[tag]) {
                                tagValid = true;
                                value = 'Budget Range';
                            }
                            break;
                        case 'newarrivals':
                            if (this.qRequest[tag]) {
                                tagValid = true;
                                value = 'New Arrivals';
                            }
                            break;
                        case 'fuelstars':
                            if (!_.isNull(this.qRequest[tag]) && !_.isEmpty(this.qRequest[tag])) {
                                tagValid = true;
                                value = this.qRequest[tag] + ' Fuel Stars';
                            }
                            break;
                        case 'seats':
                            if (!_.isNull(this.qRequest[tag]) && !_.isEmpty(this.qRequest[tag])) {
                                tagValid = true;
                                value = this.qRequest[tag] + ' seats';
                            }
                            break;
                        case 'fueltype':
                            if (!_.isEmpty(this.qRequest[tag])) {
                                tagValid = true;
                                value = _.join(this.qRequest[tag], ',');
                            }
                            break;
                        case 'rangetype':
                            if (_.get(this.qRequest, 'filterrange', null) == 'price') {
                                if (this.qRequest.rangetype == 'price') {
                                    tagValid = true;
                                    value = '$' + this.formatWithCommas(this.qRequest.pricemin,0) + '-$' + (this.qRequest.pricemax >= 50000 ? '50k+' : this.formatWithCommas(this.qRequest.pricemax,0) ) ;
                                } else if(this.qRequest.rangetype == 'weeklypayment') {
                                    tagValid = true;
                                    value = '$' + this.number_format(this.qRequest.paymentmin,0) + '-$' + (this.qRequest.paymentmax >= 200 ? '200+ p/w' : this.number_format(this.qRequest.paymentmax,0) + " p/w" ) ;
                                }
                            } else if (_.get(this.qRequest, 'filterrange', null) == 'km') {
                                tagValid = true;
                                value = (this.formatWithCommas(this.qRequest.kmmin/1000)) + '-' + (this.formatWithCommas(this.qRequest.kmmax/1000)) + 'K kms';
                            }
                            break;
                        default:
                            if (!_.isNull(this.qRequest[tag]) && !_.isEmpty(this.qRequest[tag])) {
                                tagValid = true;
                                value = this.qRequest[tag];
                            }
                            break;
                    }
                    if (tagValid) {
                        searchtags.push({
                            key: tag,
                            value: this.decodeTagValue(value)
                        });
                    }
                }
            });
            this.searchtags = searchtags;
        },

        updateSearchTags(key, value) {
            // drop the initial value
            let searchtags = this.searchtags.filter((st) => {
                return st.key != key;
            });
            searchtags.push({
                key,
                value: this.decodeTagValue(value),
            });
            this.searchtags = searchtags;
        },

        removeTag(tag) {
            delete this.qRequest[tag];
            this.searchtags = this.searchtags.filter((st) => {
                return st.key != tag;
            });
            this.queryVehicles().then(() => {
                this.initJS();
            });
        },

        removeKeywords() {
            delete this.qRequest['keywords'];
            this.currentQuery.keywords = null;

            // reset to first page
            this.changePage(1, true, false);
            this.queryVehicles(false, false, true).then(() => {
                this.initJS();
            });
        },

        initJS() {
            this.$nextTick(() => {
                // this.initSelect();
                initListingModals();
                initWeeklyPrices();
            });
        },

        initSelect() {
            return;
            // let pickers =  $(this.$refs.selectpicker);
            // if (pickers.length) {
            //     $(this.$refs.selectpicker).selectpicker({
            //         style: 'btn-select',
            //         iconBase: 'fa',
            //         tickIcon: 'fa-check',
            //     }).on('changed.bs.select', (e) => {
            //        //
            //     });
            // }
        },

        canPromo(index, page) {
            if (_.isEmpty(this.promocards)) {
                return false;
            }

            let plusserMin = 6;
            let plusserMax = 13;
            if (window.innerWidth >= 2000) {
                plusserMax = 12;
            }

            let indPage = parseInt(page - 1); // reset page index to 0
            let firstIndex = (indPage * this.perPage)  + plusserMin;
            let lastIndex = (indPage * this.perPage) + plusserMax;

            let firstPromoIndex = (indPage * 2);
            let lastPromoIndex = firstPromoIndex + 1;

            if (this.listings.length >= 8) {
                if (index == firstIndex) {
                    return _.get(this.promocards, firstPromoIndex, false);
                }
                if (index == lastIndex) {
                    return _.get(this.promocards, lastPromoIndex, false);
                }
            }
            return false;
        },

        canElfsight(index, page) {
            if (!this.elfsightBanner || this.loading) {
                return false;
            }

            let indPage = parseInt(page - 1); // reset page index to 0
            let elfsightStart = parseInt(this.elfsightStart + (indPage * this.perPage));

            // screen specific
            if (window.innerWidth >= 2000) {
                elfsightStart = elfsightStart;
            }
            if (window.innerWidth >= 992 && window.innerWidth < 1440) {
                elfsightStart = elfsightStart - (1 * indPage);
            }

            if ((this.listings.length >= this.perPage && index == elfsightStart ) || (this.listings.length < this.perPage && index == this.listings.length)) {
                // console.log('CANELFSIGHT:', index, page, 'YES');
                return true;
            }
            // console.log('CANELFSIGHT:', index, page, 'NO');
            return false;
        },

        lazyLoad() {
            let lLess = $(this.$refs.loadLess);
            let lMore = $(this.$refs.loadMore);

            if (!this.pageLoading) {
                if (this.inViewport(lLess)) {
                    this.changePage(this.currentPage - 1, false);

                }
                if (this.inViewport(lMore)) {
                    this.changePage(this.currentPage + 1, false);
                }
            }
        },

        inViewport(item) {
            if (!_.isEmpty(item)) {
                const docViewTop = $(window).scrollTop();
                const docViewBottom = docViewTop + $(window).height();
                const elemTop = item.offset().top;
                if ((elemTop <= docViewBottom) && (elemTop >= docViewTop)) {
                    return true;
                }
            }
            return false;
        },

        number_format(value, decimal) {
            return parseFloat(value).toFixed(decimal);
        },

        formatWithCommas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        decodeTagValue(value) {
            let parsed = decodeURI(value);
            parsed = parsed.replace(/_/g, ' ');
            parsed = parsed.replace(/-/g, '/');
            return parsed;
        },

        handleTermsModalUpdate(savings, fullPrice) {
            this.termsModalSavings = savings;
            this.termsModalFullPrice = fullPrice;
        }
    }
}
</script>
